


















































































import { Component, Vue } from 'vue-property-decorator';
import Auth from '@/services/Auth';
import Brand from '@/services/Brand';

// @ts-ignore

@Component({
	name: 'Footer',
	components: {},
})
export default class Footer extends Vue {
	private Auth: any = Auth;
	private year: any = new Date();
	private component: () => any = () => null;

	get details() {
		return Brand.getBrandInformation();
	}

	get brand() {
		return Brand.getBrand();
	}

	get version(): string {
		const commitIdShort: string = process.env.VUE_APP_VERSION_COMMIT_ID
			? process.env.VUE_APP_VERSION_COMMIT_ID.substring(0, 7)
			: '?';
		return `Version: ${commitIdShort}`;
	}

	private mounted() {
		switch (Brand.getBrand()) {
			case 'umia':
				this.component = () =>
					import(
						/* webpackChunkName: "footer" */ '@/components/Global/Footer/UmiaFooter.vue'
					);
				break;

			case 'insurecareteams':
				this.component = () =>
					import(
						/* webpackChunkName: "footer" */ '@/components/Global/Footer/InsureCareTeams.vue'
					);
				break;

			case 'mmic':
				this.component = () =>
					import(/* webpackChunkName: "footer" */ '@/components/Global/Footer/Mmic.vue');
				break;

			case 'amic':
				this.component = () =>
					import(/* webpackChunkName: "footer" */ '@/components/Global/Footer/Amic.vue');
				break;

			case 'rrg': 
			this.component = () =>
					import(/* webpackChunkName: "footer" */ '@/components/Global/Footer/Rrg.vue');
			break;

		}
	}
}
